import { Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import DynamicFormWithoutSave from "../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../components/withRouter";
import { noInternetMsg } from "../../config/messageconstant";
import { getCountry } from "../../Slice/country.slice";
import { getBillHeaderId } from "../../Slice/orderBillList.slice";
import { apiGet } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import RTTable from "../../components/Comman/RT/RTTable";
import { companyTargetJson } from "../../DynamicFormsJson/Transaction/companyTarget";
import { ConvertAmount } from "../../components/Comman/ConvertValueWithDenominator";

class CompanyAndTargetView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      DataToSet: [],
      companyDetailsList: [],
    };
    this.columns = [
      {
        title: "Sr.No.",
        name: "index",
        align: "center",
      },
      {
        title: "Month",
        name: "monthType",
      },
      {
        title: "Target",
        name: "target",
        align: "center",
      },
    ];
  }

  async componentDidMount() {
    const { showLoador, showNotification } = this.props;

    const monthMapping = {
      jan: "January",
      feb: "February",
      march: "March",
      april: "April",
      may: "May",
      jun: "June",
      july: "July",
      aug: "August",
      sep: "September",
      oct: "October",
      nov: "November",
      dec: "December",
    };

    if (navigator.onLine) {
      if (this.props.params.id) {
        showLoador({ loador: true });
        apiGet({
          url: companyTargetJson.apiBaseURL + "/" + this.props.params.id,
        }).then(({ data, success }) => {
          showLoador({ loador: false });

          if (!success) {
          } else {
            let rowList = Object.keys(monthMapping).map((monthKey, index) => {
              return {
                index: index + 1,
                monthType: monthMapping[monthKey],
                target: data.data[monthKey] ? ConvertAmount({ amount: data.data[monthKey] }) : 0,
              };
            });

            this.setState({
              companyDetailsList: rowList,
              DataToSet: [
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Year",
                  value:
                    data.data.yearMaster !== null &&
                      data.data.yearMaster.yearName !== null
                      ? data.data.yearMaster.yearName
                      : "",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Total Target",
                  value:
                    data.data !== null && data.data.totalTarget !== null
                      ? ConvertAmount({ amount: data.data.totalTarget })
                      : "-",
                },
                {
                  xs: 12,
                  sm: 6,
                  md: 6,
                  lg: 6,
                  label: "Achieved Target",
                  value:
                    data.data !== null && data.data.achievedTarget !== null
                      ? ConvertAmount({ amount: data.data.achievedTarget })
                      : "-",
                },
              ],
            });
          }
        });
      }
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  }

  render() {
    const { dynamicMasterData, DataToSet, companyDetailsList } = this.state;
    return (
      <>
        <Paper
          sx={{
            p: 2,
            borderRadius: 0,
          }}
          elevation={0}
        >
          <DynamicFormWithoutSave
            showBackToList={true}
            DataToSet={DataToSet}
            dynamicMasterData={dynamicMasterData}
            showTitle={true}
            screenTitle={"Company Target View"}
            fieldMeta={[]}
            apiBaseURL={companyTargetJson.apiBaseURL}
            showSaveNextBtn={[]}
            saveBtnText={"Search"}
            showSaveBtnMain={false}
          />

          <RTTable
            columns={this.columns}
            tableData={companyDetailsList}
            isActionColActive={false}
            showPegination={false}
          />
        </Paper>
      </>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  showNotification,
  showLoador,
  getBillHeaderId,
  getCountry,
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(CompanyAndTargetView);

